import { Component, OnDestroy, inject } from '@angular/core';
import { ServerErrorService } from '../../services/server-error/server-error.service';

@Component({
  selector: 'wm-service-unavailable',
  templateUrl: './service-unavailable.component.html',
  styleUrls: ['./service-unavailable.component.less'],
})
export class ServiceUnavailableComponent implements OnDestroy {
  private readonly serverErrorService = inject(ServerErrorService);

  public ngOnDestroy(): void {
    this.serverErrorService.setServerError(false);
  }
}
